import { GOOGLE_CLIENT_ID } from '../constants/api.js'

const GOOGLE_SCRIPT_ID = 'google-identity-services'

let googleScriptPromise

export const hasGoogleClientId = Boolean(GOOGLE_CLIENT_ID)

export const loadGoogleIdentity = () => {
  if (!hasGoogleClientId) {
    return Promise.reject(new Error('Google client ID is not configured'))
  }

  if (typeof window === 'undefined') {
    return Promise.reject(new Error('Google sign-in is only available in the browser'))
  }

  if (window.google?.accounts?.id) {
    return Promise.resolve(window.google)
  }

  if (!googleScriptPromise) {
    googleScriptPromise = new Promise((resolve, reject) => {
      const existingScript = document.getElementById(GOOGLE_SCRIPT_ID)

      if (existingScript) {
        existingScript.addEventListener('load', () => resolve(window.google), { once: true })
        existingScript.addEventListener('error', () => reject(new Error('Failed to load Google sign-in')), { once: true })
        return
      }

      const script = document.createElement('script')
      script.id = GOOGLE_SCRIPT_ID
      script.src = 'https://accounts.google.com/gsi/client'
      script.async = true
      script.defer = true
      script.onload = () => resolve(window.google)
      script.onerror = () => reject(new Error('Failed to load Google sign-in'))
      document.head.appendChild(script)
    }).catch((error) => {
      googleScriptPromise = undefined
      throw error
    })
  }

  return googleScriptPromise
}
